<div class="life-cycle-list">
  <div class="badge rounded-pill life-cycle-list__on-change">ngOnChange</div>
  <div class="badge rounded-pill life-cycle-list__on-init">ngOnInit</div>
  <div class="badge rounded-pill life-cycle-list__do-check">ngDoCheck</div>
  <div class="badge rounded-pill life-cycle-list__after-content-init">
    ngAfterContentInit
  </div>
  <div class="badge rounded-pill life-cycle-list__after-content-checked">
    ngAfterContentChecked
  </div>
  <div class="badge rounded-pill life-cycle-list__after-view-init">
    ngAfterViewInit
  </div>
  <div class="badge rounded-pill life-cycle-list__after-view-checked">
    ngAfterViewChecked
  </div>
  <div class="badge rounded-pill life-cycle-list__after-view-destroy">
    ngOnDestroy
  </div>
</div>
